$(document).on 'click', 'a.close_modal', (event) -> 
    hide_modal()
    false

hide_modal = ->

    $('.modal').hide()
    $('.modal').removeClass 'shown'
    $('#full_background').removeClass 'shown'


show_modal = (element) -> 

  $('#full_background').addClass 'shown'
  $('#full_background').fadeIn()


  modal = $('#'+element.attr('data-modal'))

  if element.data('ajax')
    output = modal.find('.output')
    $.ajax(
        url: '/ajax/' +element.data('ajax') + '.script'
        type: 'POST'
        dataType: 'JSON'
        data:
          variable: element.data('var')
            
    ).done((data) ->
        output.html(data.html_output)
        console.log data
        modal.show()

        if modal.data('callback')
          call(data('callback'))

        return
    ).fail (jqXHR) ->
        console.error jqXHR.responseText
        return
  else
    modal.show()

  false

$(document).on 'click', 'a.show_modal', (event) -> 
  show_modal($(@))

  if $(@).data('modal') == 'map_modal'
    if maps['drivers_map']
      maps['drivers_map'].invalidateSize()


  false